module.exports = __webpack_public_path__ + "cvw-icon.png?8de72ff4e5ffe758dfe7c699be8dfffa";